import GetIntegrationCallOverviewRequestModelBase from '../_generated/modelBases/get-integration-call-overview-request-model-base';

export default class GetIntegrationCallOverviewRequestModel extends GetIntegrationCallOverviewRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
